import React from "react";
import { connect } from "react-redux";
import language from "../../language";
import { Table } from "../Table";
import { Modal, DeleteModal } from "../Modal";
import { CSVLink } from "react-csv";
import hospitalQuery, {
  deleteHospital,
} from "../../utils/queries/hospitalQuery";
import exportPDF from "../../utils/exportPDF";
import NewHospital from "./NewHospital";
import { defineRole } from "../../utils/handleAccessRoles";
import { getStorage } from "../../utils/storage";
import { ROLE_HOSPITAL } from "../../constants/ROLES";
import icons from "../../constants/icons";

// eslint-disable-next-line no-unused-vars
let copyData = [];
// eslint-disable-next-line no-unused-vars

class Hospitals extends React.Component {
  csvDownload = React.createRef();

  state = {
    isLoading: false,
    data: [],
    page: 1,
    limit: 10,
    search_text: "",
    selected_data: {},
    delete_value: "",
    error: {},
    csvData: [],
    user: {},
  };

  componentDidMount = async () => {
    const user = await getStorage();

    this.setState({ user });

    await this.getData(true);
  };

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      [field]: e?.target?.value,
      error,
    });
  }

  getData = async (isLoading, search = {}) => {
    try {
      const { page, limit } = this.state;
      const { defaultLanguage } = this.props;

      this.setState({ isLoading });

      const { data, count, totalRecords } = await hospitalQuery(defaultLanguage, {
        page,
        limit,
        ...search,
      });

      this.setState({
        data: data,
        totalPageCount: count,
        totalRecords,
        isLoading: false,
      });

      copyData = data.slice(0);
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  handlePagination(page, _tab, limit) {
    this.setState(
      {
        page,
        ...(limit != null && { limit }),
      },
      () => {
        this.getData(true);
      }
    );
  }

  handleShowModal(modal, modalTitle, selected_data = {}) {
    console.log("modal open object", {
      modal,
      modalTitle,
      selected_data,
    });
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selected_data,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].code,
        key: "code",
        type: "link",
        onPress: (item) => this.handleShowModal("showModal", item.name, item),
        styles: { textTransform: "uppercase" },
      },
      {
        title: language[this.props.defaultLanguage].name,
        key: "name",
        styles: { textTransform: "uppercase" },
      },
      {
        title: language[this.props.defaultLanguage].stock_name,
        key: "bloodBank.name",
        styles: { textTransform: "uppercase" },
      },
      {
        title: language[this.props.defaultLanguage].allowed_blood_banks_to_request_from,
        key: "allowedBloodBank.name",
        styles: { textTransform: "uppercase" },
      },
      {
        title: language[this.props.defaultLanguage].multiple_allowed_blood_banks_to_request_from,
        key: "multipleAllowedBloodBank",
        render: (item) =>
          Array.isArray(item.multipleAllowedBloodBank) && item.multipleAllowedBloodBank.length > 0
            ? item.multipleAllowedBloodBank.map((b) => b?.name || b).join(", ")
            : "-",
      },
      {
        title: language[this.props.defaultLanguage].allowed_products,
        key: "allowedProducts",
        render: (item) =>
          Array.isArray(item.allowedProducts) && item.allowedProducts.length > 0
            ? item.allowedProducts.map((p) => p?.name || p).join(", ")
            : "-",
      },
      {
        title: language[this.props.defaultLanguage].type,
        key: "type",
        styles: { textTransform: "capitalize" },
      },
      {
        title: language[this.props.defaultLanguage].province,
        key: "address.province",
        styles: { textTransform: "capitalize" },
      },
      {
        title: language[this.props.defaultLanguage].district,
        key: "address.district",
        styles: { textTransform: "capitalize" },
      },
      {
        title: language[this.props.defaultLanguage].sector,
        key: "address.sector",
        styles: { textTransform: "capitalize" },
      },
      {
        title: language[this.props.defaultLanguage].cell,
        key: "address.cell",
        styles: { textTransform: "capitalize" },
      },
      {
        title: language[this.props.defaultLanguage].village,
        key: "address.village",
        styles: { textTransform: "capitalize" },
      },
      defineRole({
        roles: this.state.user.accessRole,
        menu: ROLE_HOSPITAL,
        operation: "update,delete",
      }) && {
        title: language[this.props.defaultLanguage].actions,
        key: "action",
      },
    ].filter(Boolean);

    return headers;
  }

  onDelete = async () => {
    try {
      this.setState({ isDeleting: true });

      await deleteHospital(
        this.props.defaultLanguage,
        this.state.selected_data._id
      );

      this.setState({ isDeleting: false });

      this.getData(true);
      this.handleCloseModal("showDeleteModal");
    } catch (error) {
      this.setState({
        isDeleting: false,
      });
    }
  };

  fetchAllForExport = async () => {
    const { defaultLanguage } = this.props;
    const result = await hospitalQuery(defaultLanguage, { page: 1, limit: 100000 });
    return Array.isArray(result) ? result : result?.data || [];
  };

  flattenForExport = (data) => {
    const lng = this.props.defaultLanguage;
    return data.map((item) => ({
      [language[lng].code]: item.code || "",
      [language[lng].name]: item.name || "",
      [language[lng].stock_name]: item.bloodBank?.name || "",
      [language[lng].allowed_blood_banks_to_request_from]: item.allowedBloodBank?.name || "",
      [language[lng].multiple_allowed_blood_banks_to_request_from]: Array.isArray(item.multipleAllowedBloodBank)
        ? item.multipleAllowedBloodBank.map((b) => b?.name || b).join(", ")
        : "",
      [language[lng].allowed_products]: Array.isArray(item.allowedProducts)
        ? item.allowedProducts.map((p) => p?.name || p).join(", ")
        : "",
      [language[lng].type]: item.type || "",
      [language[lng].province]: item.address?.province || "",
      [language[lng].district]: item.address?.district || "",
      [language[lng].sector]: item.address?.sector || "",
      [language[lng].cell]: item.address?.cell || "",
      [language[lng].village]: item.address?.village || "",
    }));
  };

  downloadExcel = async () => {
    try {
      this.setState({ isExporting: true });
      const raw = await this.fetchAllForExport();
      const flat = this.flattenForExport(raw);
      this.setState({ isExporting: false, csvData: flat }, () => {
        this.csvDownload.current?.link.click();
      });
    } catch (error) {
      this.setState({ isExporting: false });
    }
  };

  downloadPDF = async () => {
    try {
      this.setState({ isExporting: true });
      const raw = await this.fetchAllForExport();
      const flat = this.flattenForExport(raw);
      const pdfHeaders = flat.length > 0
        ? Object.keys(flat[0]).map((key) => ({ title: key, key }))
        : [];
      this.setState({ isExporting: false });
      exportPDF("Hospitals", pdfHeaders, flat);
    } catch (error) {
      this.setState({ isExporting: false });
    }
  };

  handleRemoteSearch = async (search) => {
    await new Promise((r) => this.setState({ searching: true, page: 1 }, r));

    await this.getData(true, {
      q: search || search !== "" ? search : undefined,
    });

    this.setState({
      searching: false,
    });
  };

  handleSearch = async (e) => {
    const search = e?.target?.value;
    this.setState({ search_text: search });
  };

  render() {
    const { delete_hospital, edit, delete_ } =
      language[this.props.defaultLanguage];

    return (
      <>
        <Table
          data={this.state.data}
          isSearch
          page={this.state.page}
          limit={this.state.limit}
          search_text={this.state.search_text}
          addSearchButton
          searching={this.state.searching}
          handleSearch={this.handleSearch.bind(this)}
          handlePressSearch={() =>
            this.handleRemoteSearch(this.state.search_text)
          }
          totalPageCount={this.state.totalPageCount}
          totalRecords={this.state.totalRecords}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          onLimitChange={(newLimit) => {
            this.setState({ limit: newLimit, page: 1 }, () => {
              this.getData(true);
            });
          }}
          headers={this.returnTableHeaders()}
          showAdd={defineRole({
            roles: this.state.user.accessRole,
            menu: ROLE_HOSPITAL,
            operation: "create",
          })}
          addButtonText={language[this.props.defaultLanguage].add}
          handleAddPressed={this.handleShowModal.bind(
            this,
            "showModal",
            language[this.props.defaultLanguage].add
          )}
          rowPress={(item) =>
            this.handleShowModal("showModal", item.name, item)
          }
          filters={[
            {
              title: language[this.props.defaultLanguage].refresh,
              button_type: "button",
              icon: icons.refresh,
              onPress: () => this.getData(true),
            },
            {
              title: language[this.props.defaultLanguage].export_,
              button_type: "dropdown",
              icon: icons.export,
              options: [
                {
                  name: "Export CSV",
                  onPress: this.downloadExcel,
                },
                {
                  name: "Export PDF",
                  onPress: this.downloadPDF,
                },
              ],
            },
          ]}
          actions={[
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: ROLE_HOSPITAL,
                operation: "update",
              }),
              name: edit,
              onPress: (item) =>
                this.handleShowModal(
                  "showModal",
                  language[this.props.defaultLanguage].edit,
                  item
                ),
            },
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: ROLE_HOSPITAL,
                operation: "delete",
              }),
              name: delete_,
              onPress: this.handleShowModal.bind(
                this,
                "showDeleteModal",
                delete_hospital
              ),
            },
          ]}
        />

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showModal")}
          show={this.state.showModal}
          title={this.state.modalTitle}
          showHeaderBottomBorder={false}
        >
          <NewHospital
            handleCloseModal={this.handleCloseModal.bind(this, "showModal")}
            getData={this.getData.bind(this)}
            {...this.state.selected_data}
          />
        </Modal>

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showDeleteModal")}
          show={this.state.showDeleteModal}
          title={this.state.modalTitle}
        >
          <DeleteModal
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showDeleteModal"
            )}
            error={this.state.error.delete_password}
            value={this.state.delete_value}
            onDelete={this.onDelete.bind(this)}
            onChange={(e) => this.onChangeText("delete_value", e)}
            isDeleting={this.state.isDeleting}
            name={this.state.selected_data.name}
            getData={this.getData.bind(this)}
          />
        </Modal>
        <CSVLink
          ref={this.csvDownload}
          filename={`entities_hospitals_${new Date().toISOString().slice(0, 10)}.csv`}
          data={this.state.csvData}
        ></CSVLink>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(Hospitals);
